import React from 'react';
import complete from "assets/img/Complete.png";

const AuthorizationStatus = () => {
  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh', // Ensures the container takes up the full height of the viewport
  };

  const cardStyle = {
    position: 'relative', // Set the position to relative for absolute positioning of the image
    width: '300px', // Set the width of the card
    padding: '40px 20px', // Add padding for spacing within the card (more top padding)
    border: '2px solid #ccc', // Add a 2px solid border with a light gray color
    borderTop: "5px solid #55D24B",
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Add a subtle box shadow for depth
    textAlign: 'center', // Center the content within the card
    margin: '0 auto', // Center the card horizontally
  };

  const tickImageStyle = {
    position: 'absolute',
    top: '-25px', // Position the image at the top
    left: '50%', // Center the image horizontally
    transform: 'translateX(-50%)', // Adjust for centering
    width: '50px',
    height: '50px',
  };

  const textStyle = {
    color: "#55D24B",
    fontSize: "30px",
    fontWeight: 'bold', 
  };

  const lineStyle = {
    borderTop: "1px solid #ccc",
    margin: "20px 0",
  };

  const bottomTextStyle = {
    fontWeight: 'bold', 
  }
  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <img
          src={complete} // Replace with the actual path or URL of your tick image
          alt="Tick"
          style={tickImageStyle}
        />
        <p style={textStyle}>Success!</p>
        <div style={lineStyle}></div>
        <p style={bottomTextStyle}>Aadhar Verify successfully. We will redirect you shortly!!</p>
      </div>
    </div>
  );
};

export default AuthorizationStatus;
